import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import AppRoutes from './routes';

import '@fortawesome/fontawesome-free/css/all.min.css';
import 'react-toastify/dist/ReactToastify.css';

import { Helmet } from 'react-helmet';
import { ToastContainer } from 'react-toastify';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { checkTokenAndLogout } from './store/exp';

const queryClient = new QueryClient();

function App() {
  const dispatch = useDispatch();

  const theme = createTheme({
    typography: {
      fontFamily: '"Poppins", sans-serif'
    }
  });

  useEffect(() => {
    dispatch(checkTokenAndLogout());

    const interval = setInterval(() => {
      dispatch(checkTokenAndLogout());
    }, 2 * 60 * 1000); // every 2 minutes

    return () => clearInterval(interval);
  }, [dispatch]);

  return (
    <>
      <Helmet>
        <title>GoCondo</title>
        <link rel="icon" href="/gocondo-new-logo-tab.png" />
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <AppRoutes />
          <ToastContainer position="bottom-right" autoClose={3000} />
        </ThemeProvider>
      </QueryClientProvider>
    </>
  );
}

export default App;
